import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SectionTaskReopenComponent } from "./sections/section-task-reopen/section-task-reopen.component";
import { SectionScheduleChangeComponent } from "./sections/section-schedule-change/section-schedule-change.component";

import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
@Component({
    selector: 'app-reason-config',
    templateUrl: './reason-config.component.html',
    styleUrls: ['./reason-config.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SectionTaskReopenComponent, SectionScheduleChangeComponent]
})
export class ReasonConfigComponent implements OnInit {

  constructor(private activityLog: ActivityLogService) { }

  ngOnInit() {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_REASONS });
  }

}
